import { render, staticRenderFns } from "./FTransactionDetail.vue?vue&type=template&id=07d86cca&"
import script from "./FTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./FTransactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./FTransactionDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports